import {Typography} from '@mui/material';
import {Tooltip} from '@jobseeker/lotus/elements';

type TruncatedTextProps = {
  text: string;
  maxLength: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  sx?: object;
};

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength,
  placement = 'top',
  sx = {},
}) => {
  const truncatedText =
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Tooltip title={text} arrow placement={placement}>
      <Typography
        variant="body2"
        noWrap
        sx={{
          width: '200px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...sx,
        }}
      >
        {truncatedText}
      </Typography>
    </Tooltip>
  );
};

TruncatedText.defaultProps = {
  placement: 'top',
};

export default TruncatedText;
